export default "https://cdn-web.disco.co/dashboard-layout-1-column-c8523ad8abef555549501cb927eb32cf.png";